import React, { useMemo } from "react";

// Lightweight CSS-based floating gold dust — no heavy libs.
export const GoldParticles = ({ count = 24, className = "" }) => {
    const particles = useMemo(() => {
        return Array.from({ length: count }).map((_, i) => {
            const size = 1 + Math.random() * 3;
            const left = Math.random() * 100;
            const bottom = -Math.random() * 20;
            const duration = 14 + Math.random() * 18;
            const delay = -Math.random() * 20;
            const dx = (Math.random() - 0.5) * 120;
            const opacity = 0.35 + Math.random() * 0.55;
            return {
                key: i,
                style: {
                    left: `${left}%`,
                    bottom: `${bottom}%`,
                    width: `${size}px`,
                    height: `${size}px`,
                    animationDuration: `${duration}s`,
                    animationDelay: `${delay}s`,
                    opacity,
                    "--dx": `${dx}px`,
                },
            };
        });
    }, [count]);

    return (
        <div
            className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
            aria-hidden="true"
        >
            {particles.map((p) => (
                <span key={p.key} className="gold-dust" style={p.style} />
            ))}
        </div>
    );
};

export default GoldParticles;
